import React from "react";
import { arrayOf, shape, string } from "prop-types";
import { connect } from "react-redux";
import Resources from "../../components/Resources";

import { findUmbraccoResources } from "./util";

const ResourcesTemplates = ({ resources }) => {
  const requiredResources = findUmbraccoResources(
    resources,
    "Cover letter template",
    "CV template"
  );

  const res = [...(requiredResources || [])];

  return <Resources resources={res} title="Templates" />;
};

ResourcesTemplates.propTypes = {
  resources: arrayOf(
    shape({
      title: string.isRequired,
      description: string.isRequired,
      link: string,
      cta: string,
    })
  ),
};

const mapStateToProps = (state) => ({
  resources: state.core.umbracoContent.resources,
});

const mapDispatchToProps = {};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(ResourcesTemplates);
